export default __webpack_public_path__ + "static/media/own-pic-1.21bf233c.jpg";